import React from "react"
import { Link } from "gatsby"
import { slide as Menu } from "react-burger-menu"

export const BurgerMenu = ({ toggleModalVisibility }) => {
  // function showSettings(event) {
  //   event.preventDefault()
  // }
  return (
    // NOTE: You also need to provide styles, see https://github.com/negomi/react-burger-menu#styling

    <Menu right disableAutoFocus className="burger-menu">
      <div className="block">
        <Link to="/" className="home-link">
          <img
            className="logo"
            src={"/images/control-gap-full-logo-white.svg"}
            alt="logo"
          />
        </Link>
      </div>
      <div className="block">
        <Link to="/#services">Services</Link>
        <Link to="/services/cybersecurity">Cybersecurity</Link>
        <Link to="/services/offensive-security">Offensive Security</Link>
        <Link to="/services/pci-compliance">PCI Compliance</Link>
        <Link to="/services/data-remediation">Data Remediation</Link>
      </div>
      <div className="block">
        <Link to="/about-us">About</Link>
      </div>
      <div className="block">
        <Link to="/blog">Blog</Link>
        <Link to="/index-pci-frequently-asked-questions">PCI-FAQs</Link>
      </div>
      <div className="block">
        <Link to="/careers">Careers</Link>
      </div>

      <div className="block burger-contact-block">
        <button
          onClick={toggleModalVisibility}
          onKeyDown={toggleModalVisibility}
        >
          Contact
        </button>
        <a href="mailto:info@controlgap.com">info@controlgap.com</a>
        <a href="tel:1-866-644-8808">1-866-644-8808</a>
      </div>
      <div className="block burger-contact-block">
        <a
          href="https://www.linkedin.com/company/control-gap-inc-?originalSubdomain=ca"
          className="linkedin"
        >
          <i className="control-gap">x</i>
        </a>
        <p
          style={{
            textAlign: "left",
            color: "white",
            padding: "13px",
            margin: "0",
            fontSize: "14px",
          }}
        >
          © Control Gap Inc. All Rights Reserved.
        </p>
        <Link to="/terms">Terms of Use</Link>
        <Link to="/privacypolicy">Privacy Policy</Link>
      </div>
    </Menu>
  )
}

export default BurgerMenu
